import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Container, Stack, Text, Title } from '@mantine/core'

const NotFoundPage = () => {
	return (
		<Container size='sm' py='xl'>
			<Stack align='center' spacing='md'>
				<Title order={1}>404 - Page Not Found</Title>
				<Text>The page you're looking for doesn't exist.</Text>
				<Button component={Link} to='/'>
					Go Home
				</Button>
			</Stack>
		</Container>
	)
}

export default NotFoundPage
